/* eslint-disable camelcase */
import _ from 'lodash';

const extractPremiumsForPaymentPlan = (quote) => {
    const premiumObj = quote.premium || {};
    let monthlyPremium = premiumObj.monthlyPremium;
    if (_.isUndefined(monthlyPremium) && !_.isUndefined(premiumObj.total)) {
        monthlyPremium = {
            amount: (premiumObj.total.amount / premiumObj.termMonths).toFixed(2),
            currency: premiumObj.total.currency
        };
    }
    return {
        publicID: quote.publicID,
        ratingPaymentMethod_ML: quote.ratingPaymentMethod_ML,
        ratingPaymentSchedule_ML: quote.ratingPaymentSchedule_ML,
        total: premiumObj.total,
        monthlyPremium: monthlyPremium,
        taxes: premiumObj.taxes,
        totalBeforeTaxes: premiumObj.totalBeforeTaxes,
        discounts_ML: quote.discounts_ML,
        discountSavings_ML: quote.discountSavings_ML
    };
};

const setPremiumsForQuote = (baseQuote, newQuote) => {
    let premiums = {};
    if (newQuote) {
        premiums = extractPremiumsForPaymentPlan(newQuote);
    } else {
        premiums = extractPremiumsForPaymentPlan(baseQuote);
    }
    baseQuote.premium.total = premiums.total;
    baseQuote.premium.monthlyPremium = premiums.monthlyPremium;
    baseQuote.premium.totalBeforeTaxes = premiums.totalBeforeTaxes;
    baseQuote.premium.taxes = premiums.taxes;
    baseQuote.discountSavings_ML = premiums.discountSavings_ML;
    baseQuote.discounts_ML = premiums.discounts_ML;
    baseQuote.ratingPaymentMethod_ML = premiums.ratingPaymentMethod_ML;
    baseQuote.ratingPaymentSchedule_ML = premiums.ratingPaymentSchedule_ML;
};

export default {
    extractPremiumsForPaymentPlan,
    setPremiumsForQuote
};
